export enum BeneficiaryType {
    ATIVO = 1,
    AUTOPATROCINADO,
    VINCULADO,
    ASSISTIDO,
    FALECIDO,
    PARCIAL,
    TRANSFERIDO,
    PENSAO_MORTE_TUTOR = 21,
    PENSAO_MORTE,
    DESLIGADO = 23,
    DEPENDENTE = 99
}
